
export function initLazyloadVideo()
{
    const lazyvideo = [].slice.call(document.querySelectorAll(".lazy-video"));
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
               if (entry.target.querySelector('source').getAttribute('data-src') !== null) {
                const source = entry.target.querySelector('source').getAttribute('data-src')
                entry.target.setAttribute('src', source);
              }
            observer.unobserve(entry.target);
          }
        });
      });
      
      lazyvideo.forEach(video => {
        observer.observe(video);
      });
    }
    else
    {
      lazyvideo.forEach(function(video) {
        if (video.querySelector('source').getAttribute('data-src') !== null) {
          const source = video.querySelector('source').getAttribute('data-src')
          video.setAttribute('src', source);
        }
      });
    }
}
